import { useMutation } from "convex/react"
import { api } from "../../../../convex/_generated/api"

export function useReferSomeone() {
  const refer = useMutation(api.jobReferrals.refer)
  return { refer }
}
